// Get label format from column, either a responsive label format or the default label format
export const getColumnLabelFormat = (column, dataStore) => {
    const { labelFormat, responsiveConfig } = column;
    if (dataStore && responsiveConfig) {
        const { breakpointSize } = dataStore;
        const breakpointConfig = responsiveConfig[breakpointSize];
        if (breakpointConfig && breakpointConfig.labelFormat) {
            return breakpointConfig.labelFormat;
        }
    }
    return labelFormat;
};

export default getColumnLabelFormat;



// WEBPACK FOOTER //
// ./src/utils/getColumnLabelFormat.ts